export const SET_IS_OVERLAY_VISIBLE = "SET_IS_OVERLAY_VISIBLE";
export const SET_JWT_TOKEN = "SET_JWT_TOKEN";
